@if(isLoading()) {
  <lib-loader/>
} @else {
  <lib-dropdown
  data-test="focus-period-selector"
  [options]="availablePeriods()"
  [model]="focusPeriod()"
  (modelChange)="updateFocusPeriod($event)"
  label="Period"
  />
}